<template>
    <div
        id="list-ordersOriginsCodes-component"
        class="w-full h-full flex flex-col"
    >
        <custom-simple-select
            v-model="option"
            label="Tipo de orden *"
            placeholder="Portal"
            :options="selectOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { ordersOriginsCodes } from "@/common/fields/orders-origins";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "OrderOriginSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "pending",
            type: String,
            require: true
        },
        enabled: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        $ordersOriginsCodes: ordersOriginsCodes
    }),
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$ordersOriginsCodes).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.option = value;
        }
    },
    mounted() {
        this.option = this.itemCurrent;
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        }
    }
};
</script>
